import React, { useEffect, useRef, useState } from "react";
import "./TrackOrTrackListItem.css";
import { Button, Col, Row, Tag, Tooltip } from "antd";
import {
  faCircleExclamation,
  faComment,
  faEllipsis,
  faHeart,
  faList,
  faMusic,
  faNotdef,
  faPaperclip,
  faPen,
  faPlay,
  faRetweet,
  faTableList,
} from "@fortawesome/free-solid-svg-icons";
import {
  setAudioLinks,
  setCurrentAudioIndex,
  setCurrentTime,
  setPlayState,
  setShowAudioLinks,
  setShowFooter,
} from "../../../Redux/AudioSlice";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import PlayButton from "../../../Components/PlayButton/PlayButton";
import ToolTipTitle from "../../../Components/ToolTipTitle/ToolTipTitle";
import Hashtag from "../../../Components/Hashtag/Hashtag";
import TimeAgoFormat from "../../../Components/TimeAgoFormat/TimeAgoFormat";
import TooltipOptions from "../../../Components/TooltipOptions/TooltipOptions";
import axios from "axios";
import CreateOrUpdatePlaylistModal from "../CreateOrUpdatePlaylistModal/CreateOrUpdatePlaylistModal";
import { onOpenCreateTracklist } from "../../../Redux/CreateUpdateTracklistSlice";

function TrackOrTrackListItem({
  isOwn = false,
  trackType = "track",
  trackOrTracklist,
}) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isPlaying = useSelector((state) => state.audio.isPlaying);
  const audioLinks = useSelector((state) => state.audio.audioLinks);
  const [mainAudioLink, setMainAudioLink] = useState(); // string
  const [currentTrack, setCurrentTrack] = useState(null);
  const [showMoreTooltip, setShowMoreTooltip] = useState(false);
  const showMoreTooltipRef = useRef(null);
  const userInfo = JSON.parse(localStorage.getItem("userInfo") || "{}");
  const testArray = [...Array(2)];
  const { openList, listType } = useSelector(
    (state) => state.createUpdateTracklist
  );

  useEffect(() => {
    setMainAudioLink(
      trackOrTracklist?.audiofiles.find(
        (audio) => audio?.isAudioOfTheTrack === true
      )?.url
    );
    setCurrentTrack(trackOrTracklist?._id);
  }, [trackOrTracklist]);

  useEffect(() => {
    const handleBlurShowmore = (event) => {
      if (
        showMoreTooltipRef.current &&
        !showMoreTooltipRef.current.contains(event.target)
      ) {
        setShowMoreTooltip(false);
      }
    };
    document.addEventListener("click", handleBlurShowmore);
    return () => {
      document.removeEventListener("click", handleBlurShowmore);
    };
  }, []);

  const handleIncreasePlayCount = async (trackOrTracklist) => {
    if (!trackOrTracklist?._id) return;
    try {
      await axios.put(
        process.env.REACT_APP_SERVER_URL +
          `/track/update-track-players-counter/${trackOrTracklist?._id}`
      );
    } catch (err) {
      console.error("Error fetching tracks or tracklists:", err);
    }
  };

  const handlePlayAudioList = () => {
    dispatch(setShowFooter(true));
    dispatch(setCurrentAudioIndex(0)); // Start from the first audio
    dispatch(
      setAudioLinks([
        {
          audioId: trackOrTracklist?._id,
          link: mainAudioLink,
          name: trackOrTracklist?.title,
          author: trackOrTracklist?.artistName,
          trackImg: trackOrTracklist?.avatar,
        },
      ])
    );
    if (currentTrack && currentTrack === audioLinks[0]?.audioId) {
      dispatch(setPlayState(!isPlaying)); // Start playing
    } else {
      dispatch(setPlayState(true)); // play first time
      if (trackOrTracklist?.publisher?._id !== userInfo?.id) {
        handleIncreasePlayCount(trackOrTracklist);
      }
    }
  };

  const handleNavigateTrackDetail = () => {
    navigate(`/trackDetail/${trackOrTracklist?._id}`);
  };

  return (
    <>
      <Row className="trackOrTrackListItem">
        <Col className="trackAvatarWrapper" span={4}>
          <img
            onClick={handleNavigateTrackDetail}
            className="trackAvatar"
            src={trackOrTracklist?.avatar || "https://picsum.photos/200/200"}
          />
        </Col>
        <Col span={20}>
          <Row>
            <Col className="trackBodyWrapper" span={18}>
              <PlayButton
                className="trackPlayButton"
                size="md"
                isPlaying={
                  audioLinks[0]?.audioId === trackOrTracklist?._id && isPlaying
                }
                onClick={handlePlayAudioList}
              />
              <div className="trackMainInfoWrapper">
                <div className="trackArtistWrapper">
                  <Tooltip
                    placement="bottom"
                    color="white"
                    overlayStyle={{ width: "150px" }}
                    title={
                      <ToolTipTitle
                        avatar={
                          trackOrTracklist?.avatar ||
                          "https://picsum.photos/200/300"
                        }
                        name={trackOrTracklist?.publisher?.username}
                        followers={
                          trackOrTracklist?.publisher?.followers?.length || 0
                        }
                      />
                    }
                  >
                    <span className="trackArtist">
                      {trackOrTracklist?.artistName}
                    </span>
                  </Tooltip>
                  {/* {testArray.map((_, index) => (
                    <>
                      <Tooltip
                        placement="bottom"
                        color="white"
                        overlayStyle={{ width: "150px" }}
                        title={
                          <ToolTipTitle
                            avatar="https://picsum.photos/200/300"
                            name="Ed sheeran"
                            followers={1092}
                          />
                        }
                      >
                        <span key={index} className="trackArtist">
                          Den xi
                        </span>
                      </Tooltip>
                      {index < testArray.length - 1 && (
                        <span className="separator">, </span>
                      )}
                    </>
                  ))} */}
                </div>
                <span className="trackName" onClick={handleNavigateTrackDetail}>
                  {trackOrTracklist?.title}
                </span>
              </div>
            </Col>
            <Col className="trackTimeAgoHashtagWrapper" span={6}>
              <span className="trackTimeAgo">
                {TimeAgoFormat(trackOrTracklist?.createdAt || new Date())}
              </span>
              <Hashtag title={trackOrTracklist?.genre?.name} />
            </Col>
          </Row>
          <Row className="trackSubInfoWrapper">
            {(trackType === "album" || trackType === "playlist") && (
              <Col className="trackListPreviewWrapper" span={24}>
                {[...Array(3)].map((_, index) => (
                  <div className="trackListPreviewItem">
                    <div className="trackListPreviewMainInfo">
                      <img
                        className="trackListPreviewImg"
                        src="https://picsum.photos/200/300"
                      />
                      <span className="trackListPreviewName">
                        {"Den xi"} - {"Shape of Den Xì"}
                      </span>
                    </div>
                    <span className="trackListPreviewViewCount">
                      <FontAwesomeIcon icon={faPlay} />{" "}
                      {trackOrTracklist?.players || 0}
                    </span>
                  </div>
                ))}
                <div className="trackListPreviewItem viewMore">Xem thêm</div>
              </Col>
            )}
            <Col className="rapInfoWrapper" span={24}>
              <div className="rapInfo">
                {!(trackType === "album" || trackType === "playlist") && (
                  <span>
                    <FontAwesomeIcon icon={faPlay} />{" "}
                    {trackOrTracklist?.players || 0}
                  </span>
                )}
                <span>
                  <FontAwesomeIcon icon={faHeart} />{" "}
                  {/* {trackOrTracklist?.likers?.length || 0} */}
                  <FontAwesomeIcon icon={faNotdef} />
                </span>
                {!(trackType === "album" || trackType === "playlist") && (
                  <span>
                    <FontAwesomeIcon icon={faComment} /> {}{" "}
                    <FontAwesomeIcon icon={faNotdef} />
                  </span>
                )}
                <span>
                  <FontAwesomeIcon icon={faRetweet} />{" "}
                  {/* {trackOrTracklist?.reposters?.length || 0} */}
                  <FontAwesomeIcon icon={faNotdef} />
                </span>
              </div>
            </Col>
            <Col span={20} className="trackButtons">
              <Button className="trackBtn" size="small" disabled>
                <FontAwesomeIcon icon={faHeart} />
                Thích
              </Button>
              {isOwn ? (
                <Button className="trackBtn" size="small" disabled>
                  <FontAwesomeIcon icon={faPen} />
                  Chỉnh sửa
                </Button>
              ) : (
                <Button className="trackBtn" size="small" disabled>
                  <FontAwesomeIcon icon={faRetweet} />
                  Đăng lại
                </Button>
              )}
              <Button className="trackBtn" size="small" disabled>
                <FontAwesomeIcon icon={faPaperclip} />
                Sao chép link
              </Button>
              <div ref={showMoreTooltipRef}>
                <Tooltip
                  open={showMoreTooltip}
                  placement="topLeft"
                  color="#F5F5F5"
                  overlayStyle={{ width: "150px" }}
                  title={
                    <MoreOptions
                      trackOrTracklist={trackOrTracklist}
                      setShowMoreTooltip={setShowMoreTooltip}
                      mainAudioLink={mainAudioLink}
                    />
                  }
                >
                  <Button
                    className="trackBtn"
                    size="small"
                    onClick={() => setShowMoreTooltip((prev) => !prev)}
                  >
                    <FontAwesomeIcon icon={faEllipsis} />
                  </Button>
                </Tooltip>
              </div>
            </Col>
            <Col span={4}>
              <div className="trackSmallNote">
                {/* <Tag color="#87d068">public</Tag> */}
                {/* <Tooltip
                  placement="left"
                  color="#F5F5F5"
                  title={
                    <span style={{ color: "black" }}>
                      Track chứa nội dung phản cảm
                    </span>
                  }
                >
                  <img
                    className="trackWarningAdultContentIcon"
                    src="/warning-sign.png"
                  />
                </Tooltip>
                {isOwn && <Tag color="#CD201F">private</Tag>} */}
                {trackType === "track" && <FontAwesomeIcon icon={faMusic} />}
                {(trackType === "album" || trackType === "playlist") && (
                  <FontAwesomeIcon icon={faTableList} />
                )}
              </div>
            </Col>
          </Row>
        </Col>
      </Row>
    </>
  );
}

function MoreOptions({ trackOrTracklist, setShowMoreTooltip, mainAudioLink }) {
  const dispatch = useDispatch();
  const audioLinks = useSelector((state) => state.audio.audioLinks);
  const currentAudioIndex = useSelector(
    (state) => state.audio.currentAudioIndex
  );
  const currentTime = useSelector((state) => state.audio.currentTime);

  const handleAddToNextUp = () => {
    setShowMoreTooltip(false);
    if (audioLinks.some((track) => track.audioId === trackOrTracklist?._id)) {
      return; // Exit if track already exist
    }
    const addNewStreamingTrack = [
      ...audioLinks,
      {
        audioId: trackOrTracklist?._id,
        link: mainAudioLink,
        name: trackOrTracklist?.title,
        author: trackOrTracklist?.artistName,
        trackImg: trackOrTracklist?.avatar,
      },
    ];

    dispatch(setShowFooter(true));
    dispatch(setShowAudioLinks());
    dispatch(setAudioLinks(addNewStreamingTrack));
    if (addNewStreamingTrack.length === 1) {
      dispatch(setCurrentAudioIndex(0));
      dispatch(setPlayState(true));
    } else {
      dispatch(setCurrentAudioIndex(currentAudioIndex));
      dispatch(setCurrentTime(currentTime));
    }
  };

  const handleAddOrCreatePlaylist = () => {
    setShowMoreTooltip(false);
    dispatch(onOpenCreateTracklist({ listType: "playlist" }));
  };

  return (
    <>
      <Row style={{ color: "black" }}>
        <TooltipOptions
          icon={faList}
          title="Thêm vào kế tiếp"
          endSecion={true}
          onClick={handleAddToNextUp}
        />
        <TooltipOptions
          icon={faTableList}
          title="Thêm vào playlist"
          endSecion={false}
          onClick={handleAddOrCreatePlaylist}
        />
      </Row>
    </>
  );
}

export default TrackOrTrackListItem;
